var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "url(#pattern0_29598_10889)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_29598_10889",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_29598_10889",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_29598_10889",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEg0lEQVR4nO2cS6hXRRyAp4Xmq0VqmIqLgrKNENUmjax2cUtaubaFRGApSBHWLitDuJGoRGCIbdoEaWDFFXoY9ECzBB/4CJRuBuLCtLq3yC8G5+I095zzP4855/xm7nxwNndmzvzmY/4zc2bOuUolEolEIpFIJBKJRMwAM4D1wHfAVfplHPgaeFDFBLAEOIo8xoAhFVFPlig5LtnABuQzFrxs4HvCYCxo2cAVZHE1StnIYwXw+4AVySoVGghDXY8pPtkIQ92IKy7ZCEP9P7Z4ZCMMNTm+OGQjDJUdY/iyEYbKjzNs2QhDFccarmyEoQbHG6ZshKHKxfxQcLIRhiofd1iyEYaqFns4shGGqh5/GLIRhqrXBvmyEYaq346VJbZY+zuDRB6LWpT9jV971YKTxksN21Mke9yfueqBSWNcy26rZ/u1Vy2oKYVKorshie6IJLojkuiOSKI7IonuiCS6I5LojpAu+jfgC+B9YAewBdgJ7AV+Aq7llPsT+BTYDbxlyulrGNij9x6AfwfUfRE4VPIaD1n0VyXusRh4N6PsjyXKLgBeNbtrWeyq0JZzUYueANhYVbRV9l7gUhJtAcwHbrX/ZqWN1BFtbeC7Q8nU7NHAi1baYWCZkz6UJxpYY8bzv4ETwNqMePYUiTZfKIzkXH/FKlpz3Em/GfgnR/QzTGa9k+eBAaLfoQGqLzyI1tzm5BmtIFqf9c228twEnLfSk2iL+xyhxyqIxj04BT6y0pJoizscUb9UFP2yk2+rlZZEG87on7slabaZ7KqIHnbyvVBjMjxJCVRfNByjL+jzOSf9cSu9rOj3nHzP5okuaMe62EQvBp4CHgXmZNzvsxqidxfkm5qii9DrYqds3aFjY0uiv1Qhiwam6wnNWj9XFf2Kk++NPNHAppwNJXtJ6HIaeET1SVXRwDLgSeAJ4GlgG/BrTtmyolc7+T70+MByMG+7IMQHFhqI1r+C2518eiXjQ/QpEZI1AkR/4OS520mvK1rvqTyspNCz6JMZvfk1T6IPKEl0LHq5XjOb63ngFid9YcY7c3VFrymYuN8088qoOfGZ7tdqz6KLAGYB32bco67ou3Lq0WJdtqi2kSAauNP8syo8ip6VU9fEzqLNaEONpRo5iB+A+63rbcpz3AwHk36awEw9WQHbB3wWsdep31765VK1vRJE++IP05vOApfbrmwqi+6UJLojkuiOSKI7IolujxGzTXuPfdibJkN/nHJPeepM/t5XGWUrDoSDwFwf7W3P8ICKA+Bn/Wqar/a2Y7dExQHwmM/2+jdbsmLhHPDdXr9WK1QsnLUltkB94WcrlTBZWmEL1BfNtlIJkzk5bfHZk10uxPb/o5uInnjnrw3ONxWddaoR6tCxucU6NzcV/RzxTIbTzEGBb/Q9pzUVrd/QP0JYfF7QHr3y2Oexrn3eDm/Ni4tHYnlgwZ9sf5Kd4NaZjyxDmCDPAfMGtOdjUZJjheuy64zZ+/WQ2nf8scvWkmf0HXfsspPkDmR/knpy+7KTZOUZI1t/UaB35fQj++tlVxf/ARXgrg2DI4DDAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportPdf);
export default __webpack_public_path__ + "static/media/Export Pdf.b26ada80efd75ba796906fdfb3030ad1.svg";
export { ForwardRef as ReactComponent };